import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'correctAnswers',
    label: 'Correct Answers',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
